
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import { useNavigate } from "react-router-dom";

import CreateProspectFormConnected from './CreateProspectForm/CreateProspectForm';
import {
    createValidator, maxLength, required, email, phoneNumber,
} from '../../utils/validation';
import { createProspects, getRegisterData } from '../../state-management/actions/prospect'
import Spinner from '../../components/Spinner/FormSpinner';
import { resetQuestions } from '../../state-management/actions/assessmentSectionQuestions';

export const validate = createValidator({
    firstName: [
        required(),
        maxLength(50),
    ],
    lastName: [
        required(),
        maxLength(50),
    ],
    email: [
        required(),
        email(),
    ],
    company: [
        required(),
        maxLength(50),
    ],
    title: [
        maxLength(50),
    ],
    phoneNumber: [
        phoneNumber(),
        required(),
    ],
    industry: [
        required(),
    ],
});

export const ClientProspect = (props) => {

    const navigate = useNavigate();
    const { onCreateProspects, isLoading, clearScores, getRegisterData: getRegisterDataAct } = props;
    const handleSubmit = (values, actions) => {
        onCreateProspects(values, { ...actions, toQuestions: (state) => navigate('/questions', { state }) });
    }

    useEffect(() => {
        clearScores();
        getRegisterDataAct();
    }, [clearScores, getRegisterDataAct]);

    const initialValues = {
        firstName: '',
        lastName: '',
        email: '',
        company: '',
        title: '',
        phoneNumber: '',
        industry: '',
    };

    return (
        <React.Fragment>
            <Formik
                component={CreateProspectFormConnected}
                initialValues={initialValues}
                onSubmit={handleSubmit}
                validate={validate}
                {...props}
            />
            {isLoading && <Spinner />}

        </React.Fragment>);
}

ClientProspect.propTypes = {
    onCreateProspects: PropTypes.func,
    isLoading: PropTypes.bool,
    clearScores: PropTypes.func,
};

ClientProspect.defaultProps = {
    onCreateProspects: () => { },
    isLoading: false,
    clearScores: () => { },
};

const mapDispatchToProps = dispatch => ({
    onCreateProspects: (values, actions) => dispatch(createProspects(values, actions)),
    clearScores: () => dispatch(resetQuestions()),
    getRegisterData: () => dispatch(getRegisterData()),
});

const mapStateToProps = (state) => ({
    isLoading: state?.prospect?.isLoading,
})

export default connect(mapStateToProps, mapDispatchToProps)(ClientProspect);
